import { useEffect, useRef } from 'react';
import type { HotelPlannerSelection } from '@voll-intelligence/genui-contract';

const AUTO_SEARCH_DELAY_MS = 400;

function selectionKey(interactionId: string, selection: HotelPlannerSelection): string {
  return JSON.stringify([interactionId, selection]);
}

export function useHotelAutoSearch({
  selection,
  settled,
  interactionId,
  disabled,
  onSearch,
}: {
  selection: HotelPlannerSelection | null;
  settled: boolean;
  interactionId: string;
  disabled: boolean;
  onSearch: (selection: HotelPlannerSelection) => void | Promise<void>;
}): void {
  const key = selection ? selectionKey(interactionId, selection) : null;
  const lastSubmitted = useRef<string | null>(null);

  useEffect(() => {
    if (!key || !selection) return undefined;
    if (settled) {
      lastSubmitted.current = key;
      return undefined;
    }
    if (disabled || key === lastSubmitted.current) return undefined;
    const timer = setTimeout(() => {
      lastSubmitted.current = key;
      void onSearch(selection);
    }, AUTO_SEARCH_DELAY_MS);
    return () => {
      clearTimeout(timer);
    };
    // `interactionId` reaches the effect through `key`.
  }, [disabled, key, onSearch, selection, settled]);
}
